import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-contact-lookup',
  templateUrl: './micro-contact-lookup.component.html'
})
export class MicroContactLookupComponent  {

  @Input()
  contactId:any;
}
